// type: "work", "personal", "toy"로 구분
// showOnHome: true인 경우 홈페이지(/)에 표시

const PROJECTS = [
  {
    id: "kakao-cloud",
    title: "Kakao Cloud",
    images: [
      {
        src: "/images/projects/kakao-cloud/01-dashboard.webp",
        caption: "카카오클라우드 콘솔 대시보드",
        alt: "카카오 클라우드 콘솔 대시보드",
      },
      {
        src: "/images/projects/kakao-cloud/02-bcs-instances.webp",
        caption: "리소스 목록 페이지",
        alt: "BCS Virtual Machine 인스턴스 목록",
      },
      {
        src: "/images/projects/kakao-cloud/03-service-detail.webp",
        caption: "리소스 상세 페이지와 패널",
        alt: "VPC 서브넷 상세와 라우팅 테이블 패널",
      },
      {
        src: "/images/projects/kakao-cloud/04-notifications-task-manager.webp",
        caption: "글로벌 노티피케이션과 테스크 매니저",
        alt: "글로벌 알림 센터와 태스크 매니저",
      },
    ],
    imageSource: {
      label: "카카오 클라우드 공식 유튜브",
      url: "https://www.youtube.com/@KakaoCloud/videos",
    },
    detailDescription:
      "카카오클라우드 콘솔의 Module Federation 기반 MFE 구조 설계·개발에 참여하여 서비스 간 평균 이동 시간을 4.8초에서 0.5초로 단축하였습니다. SSR 인증·권한 검증을 병렬화하여 TTFB와 LCP도 2배 이상 개선하였습니다.\n\nSSE 기반 글로벌 알림과 태스크 매니저를 개발하여 리소스 상태와 작업 진행률·실패 정보를 실시간으로 제공하였습니다. 이벤트 수신과 데이터 갱신 구조를 공통화하고, 연결 복구와 진행 중인 작업의 폴링 정책을 구현하였습니다.\n\n30개 서비스에 PR별 MFE 프리뷰 환경을 구축하여 PR 생성 후 3분 이내에 변경 화면을 검증하도록 개선하였습니다. 언더클라우드 로그 적재를 위한 ELK 스택도 도입하였습니다.",
    type: "work",
    showOnHome: true,
    date: "2023. 07 - Present",
    summary:
      "대규모 웹 서비스 운영을 위해 MFE를 설계하고 도입하였습니다. 사용자 체감 속도를 10배 가까이 향상시켰으며, 모니터링 시스템 구축과 테스트 코드 작성 등을 통해 서비스 안정성을 향상시켰습니다.",
    descriptions: [
      "Module Federation 기반 MFE 구조 설계·개발에 참여하고, 서비스 간 평균 이동 시간을 4.8초에서 0.5초로 단축",
      "SSE 기반 글로벌 알림과 태스크 매니저를 구축하여 리소스 상태 변경과 작업 진행률·실패 정보를 실시간으로 제공",
      "30개 서비스에 PR별 MFE 프리뷰 환경을 구축하여 PR 생성 후 3분 이내에 변경 화면을 검증할 수 있도록 개선",
      "클라우드 플랫폼 ‘Kakao Cloud’ 콘솔 개발",
      "언더클라우드 로그 적재를 위해 ELK 스택 도입",
    ],
    stacks: [
      "nextjs",
      "module-federation",
      "zustand",
      "react-query",
      "sentry",
      "elasticsearch",
      "vitest",
    ],
  },

  {
    id: "kiml",
    title: "Kakao i Machine Learning",
    detailDescription:
      "MLOps 플랫폼 Kakao i Machine Learning의 정식 서비스 출시 과정에 기획 단계부터 참여하였습니다. Next.js와 TypeScript 기반으로 프론트엔드를 재구성하고, 홈·워크스페이스·데이터셋·스토리지 등 주요 화면을 개발하였습니다.\n\n컴포넌트 주도 개발(CDD)과 Storybook CI/CD로 협업 환경을 정비하고, BFF를 구축하여 화면에 필요한 형태로 API 응답을 구성하였습니다. Sentry 기반 에러 모니터링과 세 차례의 QA 대응으로 출시 준비와 운영을 지원하였습니다.",
    images: [
      {
        src: "/images/projects/kiml/01-platform-overview.webp",
        caption: "Kakao i Machine Learning 소개 이미지",
        alt: "Kakao i Machine Learning 소개 이미지: 리소스 사용량과 작업 계보 추적 대시보드",
      },
    ],
    type: "work",
    showOnHome: true,
    date: "2022. 08 - 2023. 07",
    summary:
      "MLOps 플랫폼 'KIML'을 개발하고 출시하였습니다. MVP 수준의 서비스를 CDD를 통해 NextJS로 효율적으로 마이그레이션 하였습니다.",
    descriptions: [
      "MLOps 플랫폼 ‘kakao i machine learning’ 개발 및 출시",
      "MVP 수준의 ‘KiML’을 Next.js로 마이그레이션하고, 컴포넌트 주도개발(CDD)을 통해 개발 효율성을 증진시킴.",
      "효율적인 API 설계를 위한 BFF 구축",
      "안정적인 운영을 위해 Sentry 도입",
    ],
    stacks: ["nextjs", "typescript", "sentry", "redux-toolkit"],
  },

  {
    id: "tech-ground",
    detailDescription:
      "사내 AI 기술을 체험할 수 있는 테크그라운드 서비스를 유지 보수하고 운영하였습니다. 언더클라우드에서 운영하던 서비스를 오버클라우드의 Kubernetes 클러스터로 이관하고, GitHub Actions로 CI/CD를 구축하였습니다.",
    title: "Tech Ground",
    images: [
      {
        src: "/images/projects/tech-ground/01-tech-ground.webp",
        caption: "Tech Ground 대표 이미지",
        alt: "파란 배경에 Tech Ground와 kakaoenterprise 이름이 표시된 대표 이미지",
      },
    ],
    type: "work",
    showOnHome: true,
    date: "2022. 05 - 2022. 12",
    summary:
      "사내 AI 기술을 체험할 수 있는 테크그라운드 서비스를 유지 보수하고 운영하였습니다. 클러스터 이관과 CICD 구축을 직접 진행하였습니다.",
    descriptions: [
      "회사의 AI 기술을 체험할 수 있는 테크그라운드 서비스 유지 보수 및 운영",
      "언더클라우드에 올라간 테크그라운드를 오버클라우드 클러스터(kakao i cloud - kubernetes)로 이관하고 Github Actions를 이용하여 CICD구축",
    ],
    logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
    stacks: ["docker", "k8s", "github-actions"],
  },

  {
    id: "token-floor",
    title: "Token Floor",
    type: "personal",
    showOnHome: false,
    date: "2026. 08 - 2026. 08",
    summary:
      "npm에 배포하여 npx token-floor로 실행할 수 있는 로컬 모니터링 도구입니다. Claude Code와 Codex의 메인·서브에이전트 작업 상태를 하나의 픽셀 오피스에서 실시간으로 확인하고, 대화 기록과 남은 사용량도 함께 살펴볼 수 있습니다.",
    descriptions: [
      "Claude Code·Codex 실시간 모니터링 도구",
      "npm에 배포하여 npx token-floor로 실행할 수 있는 로컬 모니터링 도구",
      "Claude Code와 Codex의 메인·서브에이전트 작업 상태를 하나의 픽셀 오피스에서 실시간으로 확인",
      "대화 기록과 남은 사용량도 함께 확인",
    ],
    detailDescription:
      "Claude Code와 Codex의 작업 상태를 한 화면에서 확인할 수 있는 로컬 모니터링 도구를 개발하고 npm에 배포하였습니다. CLI와 웹 화면을 하나의 패키지로 묶어 npx token-floor로 실행하도록 구성하였습니다.\n\nClaude Code의 훅과 Codex의 로컬 세션 기록을 수집하고, 서로 다른 형식을 공통 이벤트로 변환하는 어댑터를 구현하였습니다. WebSocket으로 변경 사항을 전달해 메인·서브에이전트의 작업 중, 입력·권한 대기, 완료와 오류 상태를 실시간으로 표시합니다. 대화와 이벤트 기록, 두 도구의 남은 사용량도 함께 확인할 수 있습니다.\n\nReact와 Phaser로 에이전트의 활동을 캐릭터의 이동과 말풍선으로 시각화하였습니다. 정제한 이벤트는 SQLite에 저장하고, 연결 단절이나 서버 재시작 시 상태와 기록을 복구하도록 구현하였습니다.",
    images: [
      {
        src: "/images/projects/token-floor/01-agents-working.webp",
        caption:
          "Claude Code와 Codex의 작업 상태를 한눈에 확인하는 픽셀 오피스",
        alt: "Claude Code와 Codex 에이전트의 상태별 집계, 사용량 카드, 작업 공간과 라운지의 캐릭터가 표시된 Token Floor 화면",
      },
      {
        src: "/images/projects/token-floor/02-all-panels-open.webp",
        caption: "픽셀 오피스 위에 펼친 메모와 이벤트 기록 패널",
        alt: "Token Floor 픽셀 오피스 왼쪽의 메모 작성·목록 패널과 오른쪽의 Claude Code·Codex 이벤트 기록 패널",
      },
    ],
    link: "https://www.npmjs.com/package/token-floor",
    stacks: ["typescript", "react", "phaser", "nodejs", "websocket", "sqlite"],
  },

  {
    id: "hayeonby",
    detailDescription:
      "디자이너가 콘텐츠를 조합해 모바일 청첩장을 제작하는 서비스를 Next.js와 Supabase로 개발하였습니다. 이미지 업로드 전 브라우저에서 리사이징과 JPEG 압축을 처리하고, 갤러리 이미지의 미리보기와 병렬 업로드를 구현하였습니다. 콘텐츠를 드래그로 재배치하는 편집 기능을 제공하고, 청첩장 수정 후 사용하지 않는 이미지 파일을 정리하도록 개발하였습니다.",
    title: "hayeonby",
    images: [
      {
        src: "/images/projects/hayeonby/01-admin.webp",
        caption: "청첩장 편집 페이지 (관리자)",
        alt: "hayeonby 어드민의 청첩장 편집 화면: 연락처, 방명록, 지도 구성",
      },
      {
        src: "/images/projects/hayeonby/02-invitation-mosaic.webp",
        caption: "청첩장 페이지 (방문자)",
        alt: "hayeonby 모바일 청첩장의 사진과 공유 버튼 화면 (인물 사진 흐림 처리)",
      },
    ],
    type: "personal",
    showOnHome: false,
    date: "2024. 05 - 2024. 06",
    summary:
      "관리자로 등록된 디자이너가 모바일 청첩장을 만들 수 있는 서비스입니다.",
    descriptions: [
      "관리자로 등록된 디자이너가 모바일 청첩장을 만들 수 있는 서비스",
      "nextjs + supabase를 사용하여 풀스택 개발 진행",
      "서버액션을 통해 supabase 데이터 로직을 감추고 클라이언트 부하를 감소시킴.",
      "디자이너가 필요로 하는 UIUX를 제공하기 위해 직접 소통하며 피드백을 서비스에 반영",
    ],
    logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
    stacks: ["nextjs", "supabase", "react-query", "react-hook-form"],
  },

  {
    id: "link-your-link",
    detailDescription:
      "자신만의 온라인 명함을 만들고 공유할 수 있는 서비스입니다. 공통 UI 컴포넌트를 개발하고, Storybook을 Chromatic에 배포하여 스냅샷 테스트로 UI 변경사항을 확인하였습니다.",
    title: "Link Your Link",
    images: [
      {
        src: "/images/projects/link-your-link/01-landing.webp",
        caption: "Link Your Link 랜딩 페이지",
        alt: "Link Your Link 랜딩 페이지: 명함 디자인 예시와 로그인 버튼",
      },
      {
        src: "/images/projects/link-your-link/02-design-selection.webp",
        caption: "명함 디자인 선택 페이지",
        alt: "Link Your Link 명함 디자인 선택 화면: 기본 및 도형 그래픽 스타일",
      },
      {
        src: "/images/projects/link-your-link/03-card-collection.webp",
        caption: "명함 목록과 상세 페이지",
        alt: "Link Your Link 명함집과 명함 상세 화면: 링크 목록 및 공유 기능",
      },
    ],
    type: "personal",
    showOnHome: false,
    date: "2023. 08 - 2024. 06",
    summary: "자신만의 온라인 명함을 만들고 공유할 수 있는 서비스입니다.",
    descriptions: [
      "자신만의 온라인 명함을 만들고 공유할 수 있는 서비스",
      "storybook 을 chromatic에 배포함으로써 스냅샷 테스트 진행 - 안정적인 공통 UI 컴포넌트 개발",
    ],
    stacks: ["storybook", "material-ui"],
  },

  {
    id: "unicorn-prism-escape",
    title: "Unicorn Prism Escape",
    type: "toy",
    showOnHome: false,
    date: "2026. 08 - 2026. 09",
    descriptions: [
      "게임 개발을 공부하며 제작한 js13kGames 2026 출품작으로, 7색 프리즘을 모아 탈출하는 10스테이지 생존 게임",
      "TypeScript와 Canvas 2D로 ECS 구조, 적 추적과 충돌 판정, 단계별 강화를 구현",
      "Web Audio API로 배경음악과 효과음을 합성하고, 정지 이미지의 일부를 움직여 캐릭터 보행을 표현",
      "이미지와 코드의 재사용 및 압축을 조합해 게임 전체를 13,309바이트 ZIP으로 구성",
    ],
    detailDescription:
      "AI의 도움을 받아 게임 개발을 공부하며, js13kGames 2026의 ‘유니콘과 무지개’ 주제에 맞춰 제작하고 출품한 생존 게임입니다. 익숙하지 않은 분야도 AI와 함께 빠르게 학습하고, 배운 내용을 실제 게임에 곧바로 적용해 볼 수 있다는 점을 경험하였습니다. 유니콘을 조종해 적을 피하고, 스테이지마다 7색 프리즘을 모아 무지개 게이트로 탈출합니다. TypeScript와 Canvas 2D를 사용하고, 게임 객체의 데이터와 처리 로직을 나누는 ECS 구조를 적용하였습니다. 적의 추적과 충돌 판정, 스테이지 사이의 강화 선택을 구현하고 프리즘 배치와 적의 종류·증원 간격을 달리해 10개 스테이지를 구성하였습니다.\n\n13KB 용량 제한 안에서 음악과 움직임을 표현하는 방법을 연구하였습니다. Web Audio API로 배경음악과 효과음을 직접 합성하고, 음표 배열을 재사용하면서 스테이지에 따라 템포와 소리의 구성을 바꾸었습니다. 캐릭터는 소수의 포즈를 좌우 반전해 여러 방향으로 재사용하고, 정지 이미지에서 다리 부분을 나눠 그리는 위치를 바꾸어 보행을 표현하였습니다. 유니콘의 걸음은 실제 이동 거리에 맞추고, 포즈마다 꼬리와 몸통이 다리와 함께 움직이지 않도록 영역과 그리는 순서를 조정하였습니다.\n\n캐릭터와 게이트는 작은 WebP 이미지로 저장하고 구름·프리즘·공격 효과는 코드로 그렸습니다. 빌드 과정에서는 코드와 이미지 데이터를 HTML 하나에 담고 Roadroller와 Zopfli로 압축하였습니다. 코드 길이만으로 용량을 판단하지 않고 최종 ZIP을 확인하며 조정해, 13,312바이트 제한 안에 게임 전체를 13,309바이트로 담았습니다.",
    images: [
      {
        src: "/images/projects/unicorn-prism-escape/01-thumbnail.webp",
        caption: "Unicorn Prism Escape 썸네일",
        alt: "구름 위의 유니콘과 악마, 7색 프리즘, 무지개 게이트와 Unicorn Prism Escape 제목이 있는 썸네일",
      },
      {
        src: "/images/projects/unicorn-prism-escape/02-early-stage.webp",
        caption: "초반 스테이지 플레이 화면",
        alt: "파란 하늘과 구름을 배경으로 유니콘을 쫓는 악마와 프리즘 수집 현황, 미니맵이 표시된 5스테이지 화면",
      },
      {
        src: "/images/projects/unicorn-prism-escape/03-late-stage.webp",
        caption: "후반 스테이지 플레이 화면",
        alt: "밤하늘에서 유니콘 주변의 감속 오라와 일반·대형 악마, 미니맵과 공격 버튼이 표시된 10스테이지 화면",
      },
    ],
    link: "https://js13kgames.com/2026/games/unicorn-prism-escape",
    stacks: [
      "typescript",
      "canvas",
      "web-audio-api",
      "roadroller",
      "zopfli",
    ],
  },

  {
    id: "stock-agent",
    title: "애덤 스미스 AI 봇",
    type: "toy",
    showOnHome: false,
    date: "2026. 01 - 2026. 04",
    summary:
      "매달 직접 예약하던 주식 매매를 일 단위로 자동화한 봇입니다. 직접 정해둔 투자 기준 안에서 AI의 조언을 참고해 매수·매도 범위를 미세하게 조정하고, 정해진 조건에 따라 주문을 실행합니다.",
    descriptions: [
      "매달 직접 예약하던 주식 매매를 일 단위로 자동화한 봇",
      "직접 정해둔 투자 기준 안에서 AI의 조언을 참고해 매수·매도 범위를 미세하게 조정",
      "정해진 조건에 따라 주문 실행",
    ],
    detailDescription:
      "매달 직접 예약하던 주식 매매를 일 단위로 자동화하기 위해 개발하고 Railway에 배포한 개인용 봇입니다. 직접 정해둔 투자 기준 안에서 시장 데이터와 뉴스를 분석한 AI의 조언을 참고해 매수·매도 범위를 미세하게 조정하도록 구성하였습니다.\n\nPython과 LangGraph를 사용해 투자 전략, 종목 관리, 리스크 검토, 거래 실행, 포트폴리오 보고, 사용자 소통을 담당하는 6개의 에이전트를 구성하였습니다. 분석과 판단에는 OpenAI LLM을 활용하고, 거래 실행은 코드에 정의한 규칙을 따르도록 구현하였습니다. 매수·매도 범위와 자산별 한도를 제한하고, 저장된 규칙과 시장 상태를 확인한 뒤 주문을 실행합니다.\n\n주문 접수와 실제 체결을 구분해 기록하고, 매매 규칙과 실행 내역은 Supabase에 저장합니다. 봇에서 종목 선정 근거와 포트폴리오 현황을 조회하고 매일 아침 리포트를 확인할 수 있도록 구성하였습니다.",
    images: [
      {
        src: "/images/projects/stock-agent/02-rationale.webp",
        caption: "봇 명령어 안내와 종목 선정 근거 조회",
        alt: "애덤 스미스 봇의 명령어 안내와 종목 선정 이유 조회 응답",
      },
      {
        src: "/images/projects/stock-agent/01-report.webp",
        caption: "매일 아침 확인하는 매매 내역과 포트폴리오 현황",
        alt: "주식 봇의 실행 내역과 포트폴리오 상태, 자산 정보가 가려진 아침 리포트 화면",
      },
      {
        src: "/images/projects/stock-agent/03-companies.webp",
        caption: "선정된 종목의 회사 소개를 선택하는 화면",
        alt: "회사명과 종목 코드가 표시된 주식 봇의 회사 소개 선택 버튼 목록",
      },
      {
        src: "/images/projects/stock-agent/04-langgraph.webp",
        caption: "LangGraph 흐름도 중 일부",
        alt: "주식 봇의 라우터에서 시장 분석, 거래 실행, 보고와 조회 노드로 분기하는 LangGraph 흐름도",
      },
    ],
    stacks: [
      "python",
      "langgraph",
      "langchain",
      "openai",
      "supabase",
      "railway",
    ],
  },

  {
    id: "japanese-agent",
    title: "원장 선생님 AI 봇",
    type: "toy",
    showOnHome: false,
    date: "2025. 11 - 2025. 12",
    summary:
      "아침마다 일본어 문장을 받아보고, AI와 대화하며 관련 표현을 익히는 학습 봇입니다. LLM을 활용해 예문을 생성하고 질문에 답하며, 배운 문장은 퀴즈와 복습으로 다시 학습할 수 있습니다.",
    descriptions: [
      "아침마다 일본어 문장을 받아보고 AI와 대화하며 관련 표현을 익히는 학습 봇",
      "LLM을 활용한 예문 생성과 질문 응답",
      "배운 문장을 퀴즈와 복습으로 다시 학습",
    ],
    detailDescription:
      "아침마다 일본어 문장을 받아보고, 궁금한 표현을 질문하거나 배운 내용을 복습할 수 있도록 개발하고 Railway에 배포한 개인용 학습 봇입니다. 문장과 함께 읽는 방법과 한국어 뜻을 제공하고, 대화로 비슷한 표현과 예문을 더 알아볼 수 있도록 구성하였습니다.\n\nPython과 LangGraph로 요청에 따라 처리 경로를 나누는 라우터를 구현하였습니다. 명령어와 버튼 입력은 정해진 경로로 연결하고, 자연어 요청은 OpenAI LLM으로 의도를 분류해 새 문장 제공, 예문 생성, 자유 대화, 퀴즈와 복습 노드로 전달합니다. 예문과 대화 응답 생성에도 LLM을 활용하며, 학습 문장과 대화 기록은 Supabase에서 관리합니다.\n\n학습한 문장은 객관식 퀴즈와 말하기·읽기 연습으로 복습할 수 있습니다. 말하기·읽기는 스스로 답을 떠올린 뒤 버튼으로 정답을 확인하는 방식이며, 퀴즈 출제와 채점은 LLM 호출 없이 처리하도록 구현하였습니다.",
    images: [
      {
        src: "/images/projects/japanese-agent/01-learning-conversation.webp",
        caption: "새 문장을 배우고 대화로 예문을 확장하는 화면",
        alt: "일본어 문장과 읽기, 한국어 뜻을 받은 뒤 비슷한 예문 다섯 개를 요청하는 대화",
      },
      {
        src: "/images/projects/japanese-agent/02-quiz.webp",
        caption: "일본어 퀴즈 메뉴와 버튼으로 답하는 객관식 문제",
        alt: "객관식, 말하기, 읽기 학습 선택 메뉴와 세 개의 답변 버튼이 있는 일본어 퀴즈",
      },
      {
        src: "/images/projects/japanese-agent/03-langgraph.webp",
        caption: "요청별 라우팅과 학습 기능을 연결한 LangGraph 흐름도",
        alt: "일본어 학습 요청을 새 문장, 예문, 자유 대화, 퀴즈와 복습 노드로 나누는 LangGraph 라우터 흐름도",
      },
    ],
    stacks: [
      "python",
      "langgraph",
      "langchain",
      "openai",
      "supabase",
      "railway",
    ],
  },

  {
    id: "breaking-the-browser",
    detailDescription:
      "브라우저 화면 위에 그림을 그리거나 사물을 활용할 수 있는 크롬 확장 앱입니다. react-konva로 캔버스 기능을 구현하고, 확장 앱 개발 환경을 직접 구축하여 크롬 웹 스토어에 배포하였습니다.",
    title: "Breaking the Browser",
    images: [
      {
        src: "/images/projects/breaking-the-browser/01-browser-effects.webp",
        caption: "Breaking the Browser 실행 화면",
        alt: "Breaking the Browser 실행 화면: GitHub 페이지 위에 그리기, 도장과 다양한 효과를 적용한 모습 및 도구 모음",
      },
    ],
    type: "toy",
    showOnHome: false,
    date: "2023. 03 - 2024. 01",
    summary:
      "브라우저 위에 툴을 사용하여 그림을 그리거나 사물을 활용할 수 있는 크롬 확장 앱입니다.",
    descriptions: [
      "브라우저 위에 툴을 사용하여 그림을 그리거나 사물을 활용할 수 있는 크롬 확장앱",
      "효율적으로 캔버스를 다루며 개발하기 위해 react-konva 사용",
      "확장앱 개발 환경을 직접 구축하고 크롬 앱스토어에 배포",
    ],
    stacks: ["react", "react-konva", "typescript"],
  },
];

export default PROJECTS;
